jQuery(document).ready(function($) {
  
    function scrollMarquee() {
        const $marquee = $(".marquee");
        const firstChild = $marquee.children().first();
        const childWidth = firstChild.outerWidth(true);

        // Animate the marquee to scroll left
        $marquee.animate(
            { left: `-${childWidth}px` },
            5000, // Adjust speed (5000ms for 5 seconds)
            "linear",
            function () {
                // After animation completes, reset and append the first child to the end
                $marquee.css("left", "0");
                firstChild.appendTo($marquee);
                scrollMarquee(); // Restart the animation
            }
        );
    }

    scrollMarquee();
  
});
